export enum IsPublicEnum {
	PUBLIC = 'public',
	COUNTERPART = 'counterpart',
}
